import React, { useCallback, useState } from 'react';
import Modal from './modals/modal.component';
import classnames from 'classnames';
import Input from './forms/input/input.component';
import moment from 'moment';

import { formatExpirationInputDate, minExpirationDate, maxExpirationDate } from './dateHelpers';

type PromptDateDialogProps = {
  title: string;
  dismissText: string;
  submitText: string;
  isVisible: boolean;
  minDate?: string;
  maxDate?: string;
  onCancel: () => void;
  onConfirm: (value: string) => void;
};

const PromptDateDialog = ({
  title,
  dismissText,
  submitText,
  isVisible,
  onCancel,
  onConfirm,
}: PromptDateDialogProps) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const isValidDate = (date: string) => {
    if (!date) {
      return false;
    }
    const selectedDate = moment(date);
    const tomorrow = moment().add(1, 'day').startOf('day');
    const oneYearFromNow = moment().add(1, 'year').endOf('day');
    return selectedDate.isSameOrAfter(tomorrow) && selectedDate.isSameOrBefore(oneYearFromNow);
  };

  const handleOnConfirm = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isValidDate(value)) {
      setError('Expiration date must be between tomorrow and one year from today.');
      return;
    }
    onConfirm(value);
    setValue('');
    setError('');
  }, [value, onConfirm]);

  const handleOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    setError('');
  }, [setValue]);

  return (
    <Modal
      className={classnames('prompt-dialog-modal')}
      title={title}
      closeAction={onCancel}
      dismissText={dismissText}
      dismissAction={onCancel}
      submitText={submitText}
      submitAction={handleOnConfirm}
      isVisible={isVisible}
    >
      <div>
        <Input
          type="date"
          name="promptExpirationDate"
          onChange={handleOnChange}
          value={value ? formatExpirationInputDate(value) : ''}
          min={minExpirationDate}
          max={maxExpirationDate}
        />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>
    </Modal>
  );
};

export default PromptDateDialog;
